import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { LOCALE_ID, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from "@angular/material/card";
import { MatNativeDateModule, MatRippleModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogModule } from "@angular/material/dialog";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginModule } from "@modules/login/login.module";
import { ModalComponent } from './components/modal/modal.component';
import { ForbiddenComponent } from './modules/forbidden/forbidden.component';
import { PrivateAreaModule } from "./modules/private-area/private-area.module";
import { AuthExpiredInterceptor } from "./interceptors/auth-expired.interceptor";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { PermissionEffects } from "./modules/permissions/store/permission.effects";
import { RoleEffects } from "./modules/roles/store/role.effects";
import { getStoreReducers, persistStoreReducer } from "./store/store.reducer";
import { UserEffects } from "./modules/users/store/user.effects";
import { ModalErrorComponent } from './components/modal-error/modal-error.component';

@NgModule({
  declarations: [AppComponent, ForbiddenComponent, ModalComponent, ModalErrorComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    PrivateAreaModule.forRoot(),
    LoginModule.forRoot(),
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDialogModule,
    HttpClientModule,
    MatCardModule,
    MatProgressBarModule,
    MatNativeDateModule,
    MatRippleModule,
    MatButtonModule,
    StoreModule.forRoot(getStoreReducers(), { metaReducers: [persistStoreReducer] }),
    EffectsModule.forRoot([
      PermissionEffects,
      RoleEffects,
      UserEffects,
    ]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    })
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'it'
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true
    },
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
